import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import {
  SUPERSET_CHAUFFEUR_LEADERBOARD,
  SUPERSET_CHAUFFEUR_LEADERBOARD_ERROR,
  SUPERSET_CHAUFFEUR_LEADERBOARD_SUCCESS,
} from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetChauffeurLeaderboard({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_CHAUFFEUR_LEADERBOARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_CHAUFFEUR_LEADERBOARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_CHAUFFEUR_LEADERBOARD_ERROR, payload: error });
  }
}

export function* watchSupersetChauffeurLeaderboard() {
  yield takeEvery(SUPERSET_CHAUFFEUR_LEADERBOARD, supersetChauffeurLeaderboard);
}

function* supersetChauffeurLeaderboardSaga() {
  yield all([fork(watchSupersetChauffeurLeaderboard)]);
}

export default supersetChauffeurLeaderboardSaga;
